<script lang="ts">
    export let data: TStaticBlocks | undefined;
    export let debug: boolean = false;

    import PageBuilder from '$src/lib/components/PageBuilder/PageBuilder.svelte';
    import type { TStaticBlocks } from '$src/lib/services/staticBlocks';
</script>

{#if data}
    <PageBuilder {...data} {debug} />
{/if}
